import { CaseStudy } from '../../types';
import { TEEMATES_HERO } from '../../assets/images';

export const teemates: CaseStudy = {
  id: '3',
  title: 'TeeMates!',
  category: 'Golf Group Management',
  imageUrl: TEEMATES_HERO,
  description: "The ultimate digital caddy. TeeMates! connects golfers with local courses and playing partners. From real-time group booking to social scorecards and live tournament tracking, it's the heartbeat of the modern golf community.",
  screenshots: [
    'https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1521791136064-7986c2923216?q=80&w=800&auto=format&fit=crop'
  ]
};